import {Model} from '@/models/Model'
import {Product} from '@/models/Product'
import {Promotion} from '@/models/Promotion'
import {DataArray} from '@/models/Response'
import Helper from '../services/Helper.js'

export class Item extends Model {
  declare id: number
  created_at: Date | null
  updated_at: Date | null
  deleted_at: Date | null
  order_id: number
  product_id: number
  product_code: string | null
  price_init: number
  price_last: number
  price_ex_vat: number
  price_in_vat: number
  price_at_bill: number
  discount_internal_percent: number | null
  discount_external_percent: number | null
  price_final: number | null
  point_final: number | null
  quantity: number | null
  total_gross: number
  total_vat: number
  total_net: number
  total_point: number | null
  last_sync_at: Date | null
  last_erp_at: Date | null
  last_signature: string | null
  erp_no: number | null
  discount_internal_amount: number | null
  discount_external_amount: number | null
  comment: string | null
  discount_p: string | null
  detail1: string | null
  order_code: string | null

  product: Product | null
  index_no: number | null

  unit: string | null

  mode: string | null

  cache_do_qty: number | null
  cache_s_qty: number | null
  cache_f_qty: number | null
  cache_inv_qty: number | null

  promotion_id: number | null
  promotion_qty: number | null

  promotion: Promotion | null
  is_start_of_promotion: boolean | null = null
  promotion_type: string | null
  promotion_pack: Item[] | null

  discount_internal_mode: string = '%'
  discount_external_mode: string = '%'
  custom:object = {}


  getSkipField(): string[] {
    return ['product', 'promotion', 'promotion_pack']
  }

  getResourceURL(): string {
    return Helper.setting.item.getResourceAPI
  }

}

export class DataItem extends DataArray {

  declare data: Item

}


export class DataItemsArray extends DataArray {

  declare data: Item[]

}

